<div class="hero" [routerLink]="product.builderButton.link">
  <img [ngClass]="{'show-before': media.isMatched(BREAKPOINTS.Standard.XSmall)}"
       *ngIf="product.image.alt"
       [src]="product.image.src" [alt]="product.image.alt"/>
  <div class="hero-content fx-layout-column fx-align--x-center fx-align--center-x"
       [ngClass]="{'no-image': !product.image.alt}">
    <div>
      <h2 [innerHTML]="product.name"></h2>
      <div class="description-block" *ngIf="product.description">
        <div [innerHtml]="product.description"></div>
        <button *ngIf="!product.children && product.builderButton.link !== 'NONE'" mat-flat-button color="primary" [routerLink]="product.builderButton.link">{{product.builderButton.text}}</button>
      </div>
    </div>
  </div>
</div>

<mbnm-shop-detail-product-blocks [products]="product.children">
</mbnm-shop-detail-product-blocks>
